export default "__VITE_ASSET__BWQtYS59__"